import RenderOnDesktop from "~/ui/RenderOnDesktop";
import RenderOnPhone from "~/ui/RenderOnPhone";
import { DesktopSearchInput } from "./DesktopSearchInput";
import PhoneSearchInput from "./PhoneSearchInput";

export default function CompanySearchInput() {
  return (
    <>
      <RenderOnDesktop>
        <DesktopSearchInput />
      </RenderOnDesktop>
      <RenderOnPhone>
        <PhoneSearchInput />
      </RenderOnPhone>
    </>
  );
}
